import React from "react";
import PropTypes from "prop-types";
import { PieChart, Pie, Cell, Legend } from "recharts";
import { formatPercentage } from "@signolteam/shared/units-of-measure";
import { useIsMobileWidth, useIsTabletWidth } from "@src/utils/mediaQuery";
import AppUtils from "@src/utils/appUtils";

const ActivityPageViewsCard = ({ title, pageViews }) => {
  const isMobile = useIsMobileWidth();
  const isMobileLG = useIsTabletWidth();

  // calculate % of page views
  const totalPageViews = pageViews.reduce((acc, curr) => acc + curr.value, 0);
  pageViews.forEach((pageView) => {
    pageView.percentage = formatPercentage(
      "0-1",
      pageView.value / totalPageViews,
    ).toString();
  });

  const startAngle = 360;
  const innerRadius = 0;
  const endAngle = 0;
  const height = isMobileLG ? 300 : 150;
  const width = isMobile ? 250 : 465;
  const outerRadius = isMobileLG ? 80 : 75;
  const xPosition = isMobile ? "200%" : isMobileLG ? "40%" : "30%";
  const yPosition = isMobile ? "30%" : "50%";
  return (
    <div className="pt-8 px-12 w-full h-full">
      <div className="font-bold md:font-extrabold text-base md:text-lg text-neutral-500 mb-4">
        {title}
      </div>
      <div className="flex justify-center pb-4" id="page-views-pie-graph">
        <PieChart width={width} height={height}>
          <Pie
            data={pageViews}
            cx={xPosition}
            cy={yPosition}
            labelLine={false}
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            dataKey="value"
            startAngle={startAngle}
            endAngle={endAngle}
            isAnimationActive={false}
          >
            {pageViews?.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.colour} />
            ))}
          </Pie>
          <Legend
            verticalAlign={isMobile ? "bottom" : "middle"}
            align={"right"}
            layout="vertical"
            iconType="circle"
            formatter={(value, entry, index) => (
              <span className="text-black">
                {value.charAt(0).toUpperCase() + value.slice(1)} (
                {pageViews[index].percentage})
              </span>
            )}
          />
        </PieChart>
      </div>
    </div>
  );
};

export const activityPageViewsCardControls = {
  title: {
    propType: PropTypes.string,
    controlType: "text",
  },
  pageViews: {
    propType: PropTypes.array,
    disable: true,
  },
};
ActivityPageViewsCard.propTypes = AppUtils.getPropTypeFromControls(
  activityPageViewsCardControls,
);

export default ActivityPageViewsCard;
